import { Err, IEvent, IGroup, IPost, IUser, Ok, Post, PostVisibility, Result, UserSpiceLevels } from '@/classes'
import { FetchFilters, FetchOptions } from '@/utils/useDataFetch'

export const postGetOneAPI = async (
	postId: string
) => {
	const response: Result<{
		post: IPost | null
		users: IUser[]
		event: IEvent | null
		group: IGroup | null
	}> = await fetchAPI('posts/get', { postId, options: { isComments: false } }, { method: 'POST' })

	return response
}

export const postsFeedAPI = async (
	filters: FetchFilters,
	options?: FetchOptions & {
		exclude?: string[]
	},
	controller?: AbortController
) => {
	const response: Result<{ items: IPost[], welcomes: IUser[], users: IUser[], events: IEvent[], groups: IGroup[], reposts: IPost[] }> = await fetchAPI('posts/feed', { filters, options }, { method: 'POST', controller })

	return response
}

export const postVoteAPI = async (
	postId: string,
	optionId: string
) => {
	const response: Result<{ post: Post }> = await fetchAPI('post/vote', { postId, optionId }, { method: 'POST' })

	return response
}

export const postPinAPI = async (
	postId: string,
	action: boolean
) => {
	const response: Result<{ post: Post }> = await fetchAPI('post/pin', { postId, action }, { method: 'POST' })
	
	return response
}

export const postEditAPI = async (
	_id: string,
	params: {
		title?: string
    content?: string
    isSpicy?: boolean
    visibility?: typeof PostVisibility[number]
	}
) => {
	const response: Result<{ post: Post }> = await fetchAPI('post/edit', { _id, params }, { method: 'POST' })
	
	return response
}

export const postCommentsGetAPI = async (
	postId: string,
	options?: FetchOptions
) => {
	const response: Result<{ posts: IPost[], users: IUser[] }> = await fetchAPI('post/comments', { postId, options }, { method: 'POST' })

	return response
}

// STORIES

export const storiesGetAPI = async (
	filters: FetchFilters,
	options?: FetchOptions & {
		exclude?: string[]
	},
	controller?: AbortController
) => {
	const response: Result<{ items: IPost[], users: IUser[] }> = await fetchAPI('stories', { filters, options }, { method: 'POST', controller })

	return response
}

export const storiesUserGetAPI = async (
	userId: string,
	filters: FetchFilters,
	options?: FetchOptions & {
		exclude?: string[]
	},
	controller?: AbortController
) => {
	const response: Result<{ posts: IPost[] }> = await fetchAPI('stories/user', { userId, filters, options }, { method: 'POST', controller })

	return response
}